export const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
})

export const baseCellClassName = 'text-xs font-lato'
export const baseHeaderCellClassName = 'text-[0.675rem] uppercase font-lato !bg-transparent'
